var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-form"},[_c('header',{staticClass:"signup-form__header",class:['signup-form__header--' + _vm.currentSection]},[_c('signup-navigation')],1),_vm._v(" "),_c('main',{staticClass:"signup-form__content",class:['signup-form__content--' + _vm.currentSection]},[_c('signup-sections')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }